module.exports = "/_next/static/images/PlayStore-a50ebc20251e9cdeef20e9ff762339c9.svg";